module.exports = __webpack_public_path__ + "img/b2b-hero.ce07955a.jpeg";